module.exports = __webpack_public_path__ + "img/ico9.7ba57497.svg";